import { Pipe, PipeTransform } from '@angular/core';

/**
 * Duration is in seconds.
 * The duration will be formatted as hh:mm:ss or mm:ss
 */
export function formatDuration(duration: number): string {
  duration = Math.floor(duration);
  const secs = duration % 60;
  const mins = Math.floor(duration / 60) % 60;
  const hours = Math.floor(duration / 60 / 60);

  return (
    (hours > 0 ? hours.toString() + ':' : '') +
    mins.toString().padStart(2, '0') +
    ':' +
    secs.toString().padStart(2, '0')
  );
}

@Pipe({
  name: 'formatDuration',
})
export class FormatDurationPipe implements PipeTransform {
  transform(value: unknown): string | undefined {
    if (typeof value === 'number') {
      return formatDuration(value);
    }

    return undefined;
  }
}
